import React, {useLayoutEffect, useRef} from 'react';
import FieldMultiselect from "../../multiselect";
import {toggleClassForNode} from "../../../../../gd/utils/dom-and-react/react-utils";
import MoreOptions from "./more-options";

type Props = {
    field           : FieldMultiselect
    model           : any,
    columnWidth?    : number,
    isHovered?      : boolean

    onDelete?       : callback
    // onChange?       : onChangeCallback
};

const BUTTONS_WIDTH = 74 // buttons that are shown on hover have width 48px + 10px margin + 16px padding

// const debug = "FieldMultiselect_TableView"
const debug = false

export default function FieldMultiselect_TableCellValue(props:Props) {

    const selfRef           : any = useRef()
    const moreOptionsRef    : any = useRef()

    const value         = _.get(props.model, props.field.fieldId, null)
    const valueOptions  = props.field._getOptions(value)

    debug && console.log(debug, 'render', props)

    useLayoutEffect(() => {
        if (selfRef.current) {
            // reserve space for buttons while not hovered
            // when is hovered width is already reduced by buttons width
            const hoverButtonsWidth = /*props.isHovered? 0 :*/ BUTTONS_WIDTH

            let moreOptions = 0
            const selfRect = selfRef.current.getBoundingClientRect()
            let rightBorder = selfRect.left + props.columnWidth - hoverButtonsWidth

            debug && console.log(debug, 'useLayoutEffect', rightBorder, selfRect, selfRef.current)

            // check child nodes in reverse order (from last to first)
            const nodes = _.reverse([...selfRef.current.childNodes])
            _.map(nodes, node=>{
                toggleClassForNode(node, 'is-hidden', false) // make node visible in order to have actual component rect
            })

            _.map(nodes, node=>{
                if (node.classList.contains('more-options')) return // skip more-options component

                const nodeRect = node.getBoundingClientRect()
                // if node's right border is more than container border then it is beyond available borders
                const isFit = rightBorder > nodeRect.right

                debug && console.log(debug, 'useLayoutEffect node', isFit, nodeRect, node)

                toggleClassForNode(node, 'is-hidden', !isFit) // hide nodes that do not fit available width

                // increase moreOptions
                if (!isFit) {
                    moreOptions++
                }

                // if any more options then available width is reduced
                // move threshold border to the left by the more options component width (~20px)
                if (moreOptions === 1) {
                    rightBorder -= 20
                }
            })

            // set more options counter
            moreOptionsRef.current.setMoreOptions(moreOptions)
        }
    }, [props.columnWidth, valueOptions])

    if (!valueOptions) return null

    return (
        <div className="flex-row-left-center w-100-percent" ref={selfRef}>
            {_.map(valueOptions, (option, key) => {
                return <props.field.components.Pill key         = {option.value}
                                                    className   = "cell-pill flex-no-shrink m-r-4"
                                                    style       = {{maxWidth: props.field.pillMaxWidth}}
                                                    option      = {option}
                                                    onDelete    = {props.onDelete}/>
            })}

            <MoreOptions ref={moreOptionsRef}/>
        </div>
    )
}